export const getErrorMessageByErrorCode = (errorCode) => {
  switch (errorCode) {
    case 618:
      return 'subscriber.uniqueId.error'
    case 661:
      return 'error.400.phoneExist'
    case 662:
      return 'error.400.phoneExist'
    case 605:
      return 'error.400.emailExist'
    default:
      return ''
  }
}

export const errorCodeFromBackendForFields = {
  uniqueId: 618,
  phoneNumber: 661,
  automatedCallPhoneNumber: 662,
  email: 605,
}
